import { ShieldCheck, Award, Users } from "lucide-react";
import { IMG } from "@/lib/site";
import { Reveal } from "@/lib/motion";

const STATS = [
  { icon: Award, value: "5.0", label: "Avaliação no Google" },
  { icon: Users, value: "500+", label: "Clientes atendidos" },
  { icon: ShieldCheck, value: "100%", label: "Vidros certificados" },
];

export const About = () => (
  <section id="sobre" className="relative py-24 lg:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      {/* images */}
      <div className="relative">
        <Reveal>
          <div className="relative aspect-[4/3] rounded-3xl overflow-hidden ring-1 ring-black/5 shadow-2xl">
            <img src={IMG.mesas} alt="Ambiente com vidros temperados" className="h-full w-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.15} className="absolute -bottom-10 -right-2 sm:right-6 w-40 sm:w-52">
          <div className="aspect-square rounded-3xl overflow-hidden ring-4 ring-white shadow-xl">
            <img src={IMG.boxDourado} alt="Box para banheiro sob medida" className="h-full w-full object-cover" />
          </div>
        </Reveal>
      </div>

      {/* copy */}
      <div>
        <Reveal>
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#55c0e0] mb-4">Sobre a Gabibox</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#012a60] leading-tight text-balance">
            Qualidade, segurança e acabamento que fazem a diferença
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-6 space-y-4 text-slate-600 leading-relaxed max-w-xl">
            <p>
              A <strong className="text-[#012a60]">Vidraçaria Gabibox</strong> é especializada em soluções
              em vidro temperado para residências, empresas e condomínios em São José, Florianópolis e
              toda a Grande Florianópolis.
            </p>
            <p>
              Nossa missão é entregar projetos personalizados com acabamento impecável, segurança,
              materiais de alta qualidade e instalação realizada por profissionais experientes.
            </p>
            <p>
              Atendemos desde pequenos projetos até grandes instalações, sempre buscando a total
              satisfação dos nossos clientes.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 grid grid-cols-3 gap-4">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-2xl border border-slate-200 bg-slate-50/60 p-5">
                <s.icon className="text-[#55c0e0] mb-3" size={22} />
                <p className="font-display text-2xl sm:text-3xl font-black text-[#012a60] leading-none">{s.value}</p>
                <p className="mt-1 text-xs text-slate-500 leading-tight">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
